import {getCurrentInstance, ref} from 'vue';

export const useResizeColumnCombobox = emit => {
  const {proxy} = getCurrentInstance();

  const cursorX = ref(0);

  let cacheColumnResize = null;
  let cacheColumnWith = 0;
  // Bắt đầu co kéo cột
  const resizeOn = (event, column) => {
    cacheColumnResize = column;
    proxy.resizeX = event.screenX;
    cacheColumnWith = Number(event.target.parentNode?.clientWidth);
    document.addEventListener('mousemove', mousemove);
    document.addEventListener('mouseup', resizeOff);
  };

  // Di chuyển co kéo cột
  const mousemove = e => {
    cursorX.value = e.screenX;

    const newWith = cursorX.value - proxy.resizeX;
    if (cacheColumnResize) {
      cacheColumnResize.width = cacheColumnWith + newWith;
    } else {
      internalWidth.value = cacheColumnWith + newWith;
      emit('update:width', internalWidth.value);
    }
  };

  const internalWidth = ref(0);

  // Ngừng co kéo cột
  const resizeOff = () => {
    document.removeEventListener('mousemove', mousemove);
    closeResizeOff();
  };

  const closeResizeOff = () => {
    document.removeEventListener('mouseup', resizeOff);
  };

  return {resizeOn, resizeOff};
};
